import { SectionProductTabsLandscapesScorecard } from "./SectionProductTabsLandscapesScorecard";
import { SectionProductTabsAbTests } from "./SectionProductTabsAbTests";

export const SectionProductTabsLandscapesAb = () => (
  <>
    <SectionProductTabsLandscapesScorecard />
    <SectionProductTabsAbTests />
  </>
);
